import React, { useEffect, useState } from "react"
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Slider from "react-slick"
import styled from "styled-components"
import {GatsbyImage} from "gatsby-plugin-image"
// import GalleryLightbox from "./GalleryLightbox"
import CarouselNextButton from "components/shared/CarouselNextButton"
import CarouselPrevButton from "components/shared/CarouselPrevButton"
import { media } from "utils/Media"

const SliderStyled = styled(Slider)`
	padding: 0 0 0 0 ;

	.slider-arrow {
		bottom: 35%;
		left: .25rem;
		/* bottom: -4rem; */
		background: ${props => props.theme.colors.primary};
		color: ${props => props.theme.colors.black};
		&.next {
			left: auto;
			right: .25rem;
		}
		
		@media (min-width: 992px) {
			height: 50px;
			/* bottom: -4rem!important; */
			
		}
		@media ${media.xl} {
			&.next {
				right: .075rem;
			}
		}
	}
	.slick-dots {
		display: flex!important;
		justify-content: center;
		bottom: -4rem;
		left: 1rem;
	}
	
	.slick-dots li  {
		button {
			
		}
	}
	.slick-dots li.slick-active  {
		button {
			background: ${props => props.theme.colors.primary};
		}
	}
`

const GallerySlider = (props) => {
	const [lightboxImages, setLightboxImages] = useState([])
	const [photoIndex, setPhotoIndex] = useState(0)
	const [isOpen, setIsOpen] = useState(false)

	const {images} = props

	useEffect(() => {
		let lightboxImages = []
		images.map((image, i) => {
			lightboxImages.push(image.localFile.publicURL)
		})

		setLightboxImages(lightboxImages)
	}, [])

	const openOnKeyDown = (e, index) => {
		if (e.keyCode === 13) {
			setPhotoIndex(index)
			setIsOpen(true)
		}
	}

	const getSliderImages = (images) => {
		let postHtml = images.map((image, i) => {
			return (
				<div
					key={i}
					className="px-1"
					role="button" 
					aria-pressed="false"
					tabIndex={i}
					onClick={() => { 
						setPhotoIndex(i)
						setIsOpen(true)
					}}
					onKeyDown={(e) => openOnKeyDown(e, i)}
				>
					<GatsbyImage image={image.localFile.resize.gatsbyImageData} alt={image.altText}/>
				</div>
			)
		})

		return postHtml
	}

	//slider settings
	const settings = {
		dots: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: false,
		lazyload: true,
		prevArrow: <CarouselPrevButton/>,
		nextArrow: <CarouselNextButton/>,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
		]
	}

	return (
		<>
			<SliderStyled {...settings}>
				{getSliderImages(images)}
			</SliderStyled>
			{isOpen && (
				<Lightbox
					mainSrc={lightboxImages[photoIndex]}
					nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]}
					prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]}
					onCloseRequest={() => setIsOpen(false)}
					onMovePrevRequest={() =>
						setPhotoIndex((photoIndex + lightboxImages.length - 1) % lightboxImages.length)
					}
					onMoveNextRequest={() =>
						setPhotoIndex((photoIndex + 1) % lightboxImages.length)
					}
				/>
			)}
		</>
	)
}

export default GallerySlider